/* tslint:disable:class-name */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map ,  catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
//
// Library Model/Services
//

import { HandleErrorService } from '../../../services/common/handle-error.service';
//
// App Service(s)
//
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';

@Injectable()
export class ddProtectionProductsService {
  //
  // Rest API Endpoint
  //
  protected protectionProductsBasePath = '';
  getProtectionProducts(dealerCode: any) : Observable<any> {
   let headerParams = new HttpHeaders();
    //let brand=(brandCode.toupperCase()=="LEXUS")?"lfs":"tfs";
    let path = this.protectionProductsBasePath + '/api/v3/tfs/pp/vspec/dealer/'+dealerCode;
      return this.httpClient.get(path)
            .pipe(
              map(response => response),
              catchError(err => this.handleErrorDetail(err))
            );
    
}

handleErrorDetail(error) {
  let errorMessage = '';
  if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
  } else {
      // server-side error            
      if (error.error instanceof Object) errorMessage = (typeof error.error.errorDesc!=undefined && error.error.errorDesc!=null)?error.error.errorDesc:"Service Error";
      else errorMessage = error.error;
  }
  return throwError(errorMessage);
}

  /**
   * Function: constructor()
   */
  constructor(private httpClient: HttpClient,
    private environment: EnvironmentConfiguration,
    private handleErrorService: HandleErrorService
  ) {
    this.protectionProductsBasePath = this.environment.PP_ENDPOINT;
  }
}






